import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const skuMediumImagesFragment = `
    on ${QueryType.skus} {
        media {
            medium {
                src
                alt
            }
        }
    }
`;

export const skuMediumImagesFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.skus]: skuMediumImagesFragment
    };
};
